import React from "react";
import { FiArrowRight, FiDownload, FiFileText } from "react-icons/fi";
import { Link } from "react-router-dom";
import Navbar2 from "../Components/Navbar2";
import { caseStudies } from "../Data/websiteUpdates";
import { customerStories } from "../Components/customerStory";
import "./PublicCollections.css";
import "../Components/css/MarketingEvidence.css";
import "../voices/voices-public-pages.css";

// Reuse the existing approved listing text and imagery without adding product claims.
const featuredStories = customerStories.filter(story => [
  "/customer-stories/24-hour-home-care-workforce-modernization",
  "/customer-stories/trivago-support-portal",
].includes(story.url));

export default function CaseStudiesLibrary() {
  return (
    <>
      <Navbar2 />
      <main className="public-collection-page vpp-page vpp-library" data-voices-theme="dark">
        <header className="public-collection-hero container vpp-intro">
          <p className="public-collection-eyebrow">Practical architecture</p>
          <h1>Case Studies</h1>
          <p>Explore customer projects and technical white papers.</p>
        </header>

        <section className="container vpp-featured-stories" aria-labelledby="customer-stories-title">
          <header className="evidence-library-heading" id="customer-stories">
            <h2 id="customer-stories-title">Customer stories</h2>
          </header>
          <div className="evidence-library-stories">
            {featuredStories.map(story => (
              <Link className="evidence-library-story" key={story.url} to={story.url}>
                <img src={story.image} alt={story.location} loading="lazy" />
                <div>
                  <p>{story.location}</p>
                  <h3>{story.title}</h3>
                  <span>Read customer story <FiArrowRight aria-hidden="true" /></span>
                </div>
              </Link>
            ))}
          </div>
        </section>
        <header className="evidence-library-heading container">
          <h2 id="technical-white-papers">Technical white papers</h2>
          <p>Architecture patterns and reference designs. These guides are not customer deployment reports.</p>
        </header>
        <section className="case-study-library container" aria-labelledby="technical-white-papers">
          {caseStudies.map((study) => (
            <article className="case-study-library__card" key={study.title}>
              <a className="case-study-library__cover" href={study.pdf} target="_blank" rel="noreferrer" aria-label={`Open ${study.title}`}>
                <img src={study.cover} alt={`${study.title} cover`} loading="lazy" />
              </a>
              <div className="case-study-library__content">
                <p className="case-study-library__category">{study.category}</p>
                <h2>{study.title}</h2>
                <p>{study.description}</p>
                <div className="case-study-library__actions">
                  <a href={study.pdf} target="_blank" rel="noreferrer">
                    <FiFileText aria-hidden="true" /> Read white paper
                  </a>
                  <a href={study.pdf} download>
                    <FiDownload aria-hidden="true" /> Download PDF
                  </a>
                </div>
              </div>
            </article>
          ))}
        </section>
      </main>
    </>
  );
}
